//External libraries
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
//Internal resources and services
import { setSnackbar } from "../../actions/snackbarActions";
//MUI components
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";

const DEFAULT_AUTO_HIDE_MS = 10000;

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const CustomizedSnackbars = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const snackbarOpen = useSelector((state) => state.snackbar.snackbarOpen);
  const snackbarType = useSelector((state) => state.snackbar.snackbarType);
  const snackbarMessage = useSelector(
    (state) => state.snackbar.snackbarMessage,
  );
  const snackbarNavPath = useSelector(
    (state) => state.snackbar.snackbarNavPath,
  );
  const snackbarNavParams = useSelector(
    (state) => state.snackbar.snackbarNavParams,
  );
  const snackbarAutoHideDuration = useSelector(
    (state) => state.snackbar.snackbarAutoHideDuration,
  );

  const autoHideDuration =
    typeof snackbarAutoHideDuration === "number" &&
    snackbarAutoHideDuration > 0
      ? snackbarAutoHideDuration
      : DEFAULT_AUTO_HIDE_MS;

  const handleClose = (event, reason) => {
    // Ignore incidental clickaway; timeout and close button still dismiss
    if (reason === "clickaway") {
      return;
    }

    if (snackbarNavPath) {
      window.scrollTo(0, 0);
      navigate(snackbarNavPath, snackbarNavParams || {});
    }

    dispatch(setSnackbar(false, snackbarType, snackbarMessage));
  };

  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={autoHideDuration}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          elevation={6}
          variant="filled"
          onClose={handleClose}
          severity={
            snackbarType === "success" ||
            snackbarType === "info" ||
            snackbarType === "warning" ||
            snackbarType === "error"
              ? snackbarType
              : "info"
          }
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Stack>
  );
};

export default CustomizedSnackbars;
